import {
  Box,
  Button,
  Grid,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { ModalPermissions } from './ModalPermission';
import { Autorenew, DeleteForever, RemoveRedEye } from '@material-ui/icons';
import { useState, useContext } from 'react';
import { toast } from 'react-toastify';

import { getAllFornecedor } from '../../services/fornecedores';
import { useEffect } from 'react';
import { InputSearch } from '../../pages/Admin/Suppliers/styles';
import { UserContext } from '../../providers/UserProvider';
import { ConfirmDeleteUser } from './ConfirmDelete';
import { RoleEnum } from '../../enums/Role.enum';
import { PermissionService } from '../../services/permission.service';

const useStyles = makeStyles((theme) => ({
  filterDiv: {
    width: '70vw',
    margin: '16px auto auto auto',
  },
  tittleContact: {
    fontSize: 18,
    fontWeight: 600,
    color: 'black',
    textTransform: 'none',
    margin: 'auto 30px 0 0',
  },
  copyButton: {
    width: '20%',
    backgroundColor: '#FE5D00',
    padding: '10px 0',
    border: 'none',
    borderRadius: '8px',
    color: 'white',
    cursor: 'pointer',
  },
  userTypeTag: {
    display: 'inline-block',
    backgroundColor: '#e6f9ed',
    color: '#219653',
    fontSize: '0.78rem',
    fontWeight: 500,
    borderRadius: '8px',
    padding: '2px 10px',
    marginLeft: 8,
    verticalAlign: 'middle',
    letterSpacing: 0.2,
  },
}));

export function TableUsers({
  users,
  supplier,
  roleType,
  changeSupplier,
  isAdminView = false,
  refreshUsers,
}) {
  const classes = useStyles();
  const [openDialog, setOpenDialog] = useState(false);
  const [user, setUser] = useState({});
  const { userState } = useContext(UserContext);

  const [suppliers, setSuppliers] = useState([]);
  const [showInput, setShowInput] = useState(true);

  async function getSuppliers() {
    const response = await getAllFornecedor();
    setSuppliers(response.data);
  }

  useEffect(() => {
    getSuppliers();
  }, []);

  function handleCopyButton() {
    navigator.clipboard.writeText(
      `${window.location.host}/cadastrar/usuario/${userState.fornecedor}`
    );
    toast('Link de cadastro copiado!', {
      position: 'bottom-right',
      hideProgressBar: true,
    });
  }

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

  const handleOpenMenu = (event, user) => {
    setAnchorEl(event.currentTarget);
    setSelectedUser(user);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedUser(null);
  };

  const handleChangeType = (newType) => {
    try {
      PermissionService.updateUser(selectedUser.EMAIL, newType);
      toast('Tipo de usuário alterado!', {
        position: 'bottom-right',
        hideProgressBar: true,
      });
      setTimeout(() => {
        refreshUsers();
        handleCloseMenu();
      }, 1000);
    } catch (e) {
      toast.error('Erro ao alterar tipo de usuário', {
        position: 'bottom-right',
        hideProgressBar: true,
      });
    }
  };

  function handleClickUser(user) {
    setUser({
      email: user.EMAIL,
      name: user.NOME,
    });
    setOpenDialog(true);
  }

  function getTitle() {
    if (supplier?.NOME && roleType === 'bibi') {
      return <strong> - {supplier.NOME}</strong>;
    }
    return 'da BIBI';
  }

  function getRoleTypeModal() {
    if (roleType === 'supplier') {
      return 'supplier';
    }
    if (supplier?.NOME && roleType === 'bibi') {
      return 'supplier';
    }
    return 'bibi';
  }

  function getSupplierToPermissions() {
    if (roleType === 'bibi' && !supplier?.ID) {
      return null;
    }

    if (roleType === 'bibi' && supplier?.ID) {
      return supplier.ID;
    }

    if (roleType === 'supplier') {
      return userState.fornecedor;
    }
  }

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);

  function handleOpenDelete(user) {
    setUserToDelete({ name: user.NOME, email: user.EMAIL });
    setOpenDeleteDialog(true);
  }

  function clearFilter() {
    changeSupplier(null);
    setShowInput(false);
    setTimeout(() => {
      setShowInput(true);
    }, 1000);
  }

  return (
    <>
      <ModalPermissions
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        user={user}
        roleType={getRoleTypeModal()}
        supplier={getSupplierToPermissions()}
      />
      <ConfirmDeleteUser
        openDialog={openDeleteDialog}
        setOpenDialog={setOpenDeleteDialog}
        user={userToDelete}
        onConfirm={() => {}}
        refreshUsers={refreshUsers}
      />
      <Box display="flex" style={{ marginTop: '25px' }}>
        <Box className={`header-div mob ${classes.filterDiv}`}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography
              className={classes.tittleContact}
              component="h2"
              variant="subtitle1"
            >
              Usuários {isAdminView && showInput ? getTitle() : ''}
            </Typography>
            <button className={classes.copyButton} onClick={handleCopyButton}>
              Copiar link de cadastro
            </button>
          </div>
          {roleType == 'bibi' && (
            <div
              style={{
                marginTop: '25px',
              }}
            >
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={6} lg={6}>
                  {showInput ? (
                    <InputSearch
                      id="brand-select"
                      classNamePrefix="select"
                      options={suppliers.map((supplier) => ({
                        value: supplier.ID,
                        label: supplier.NOME,
                        ...supplier,
                      }))}
                      placeholder="Selecione um fornecedor"
                      onChange={(e) => changeSupplier(e)}
                      noOptionsMessage={() => 'Nenhum fornecedor encontrado'}
                    />
                  ) : (
                    <span>Carregando</span>
                  )}
                </Grid>
                <Grid item xs={12} md={3} lg={3}>
                  <Button onClick={clearFilter} variant="text" color="primary">
                    <strong>Limpar Filtro</strong>
                  </Button>
                </Grid>
              </Grid>
            </div>
          )}
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ marginTop: '25px' }}
          >
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight: 'bold' }}> Nome</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}> Email</TableCell>
                    <TableCell
                      style={{
                        fontWeight: 'bold',
                        width: '125px',
                        textAlign: 'center',
                      }}
                    >
                      Ações
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users
                    .filter((user) => user.EMAIL !== userState.userEmail)
                    .map((user) => {
                      return (
                        <TableRow key={user.EMAIL}>
                          <TableCell style={{ fontWeight: 'normal' }}>
                            {user.NOME}
                            <span className={classes.userTypeTag}>
                              {RoleEnum[user.TIPO]}
                            </span>
                          </TableCell>
                          <TableCell style={{ fontWeight: 'normal' }}>
                            {user.EMAIL}
                          </TableCell>
                          <TableCell
                            style={{ width: '125px', textAlign: 'center' }}
                          >
                            <ButtonAction
                              onClick={(event) => handleOpenMenu(event, user)}
                              title="Alterar tipo"
                              icon={<Autorenew style={{ color: '#06C8A9' }} />}
                            />

                            <ButtonAction
                              onClick={() => handleOpenDelete(user)}
                              title="Excluir"
                              icon={
                                <DeleteForever
                                  style={{
                                    color: ['A', 'BA', 'FA'].includes(user.TIPO)
                                      ? 'rgb(240, 61, 75, .5)'
                                      : '#F03D4B',
                                  }}
                                />
                              }
                              disabled={['A', 'BA', 'FA'].includes(user.TIPO)}
                            />
                            <ButtonAction
                              onClick={() => handleClickUser(user)}
                              title="Editar permissões"
                              disabled={['A', 'BA', 'FA'].includes(user.TIPO)}
                              icon={<RemoveRedEye />}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}

                  <Menu
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleCloseMenu}
                  >
                    {selectedUser &&
                      (selectedUser.TIPO === 'BA' ||
                        selectedUser.TIPO === 'B') && (
                        <MenuItem
                          onClick={() =>
                            handleChangeType(
                              selectedUser.TIPO === 'BA' ? 'B' : 'BA'
                            )
                          }
                        >
                          <span style={{ color: 'black' }}>
                            {selectedUser.TIPO === 'BA'
                              ? 'Tornar Usuário Comum'
                              : 'Tornar Admin'}
                          </span>
                        </MenuItem>
                      )}
                    {selectedUser &&
                      (selectedUser.TIPO === 'FA' ||
                        selectedUser.TIPO === 'F') && (
                        <MenuItem
                          onClick={() =>
                            handleChangeType(
                              selectedUser.TIPO === 'FA' ? 'F' : 'FA'
                            )
                          }
                        >
                          <span style={{ color: 'black' }}>
                            {selectedUser.TIPO === 'FA'
                              ? 'Tornar Usuário Comum'
                              : 'Tornar Admin'}
                          </span>
                        </MenuItem>
                      )}
                  </Menu>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Box>
      </Box>
    </>
  );
}

export function ButtonAction({ onClick, title, icon, disabled = false }) {
  return (
    <button
      style={{
        border: 'none',
        background: 'transparent',
        cursor: disabled ? 'not-allowed' : 'pointer',
      }}
      onClick={onClick}
      disabled={disabled}
    >
      <Tooltip title={title}>{icon}</Tooltip>
    </button>
  );
}
